import React, { useState } from "react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import animation from "../assets/animation.webp";
import vfx from "../assets/VFX.webp";
import gaming from "../assets/gaming.webp";
import videoEditing from "../assets/video-editing.webp";
import motionGrahics from "../assets/Motion-Graphics.webp";
import GraphicDesign from "../assets/Graphic_design.webp";
import UIUX from "../assets/UIUX.webp";
import ScrollToHomeButton from "./ScrollToHomeButton";

const courseDetails = {
  ANIMATION: [
    {
      title: "PRO 3D CREATOR",
      duration: "3 Months",
      content: "Modeling, Texturing, Lighting, Rendering",
      industries: [
        "Film & Animation Studios",
        "Gaming Industry",
        "Architectural & Interior Design Studios",
        "Advertising Agencies",
        "E-commerce Product Visualization",
        "Medical & Scientific Visualization",
        "Industrial & Mechanical Animation",
        "E-learning & Educational Content Development",
      ],
      roles: [
        "3D Artist",
        "Modeling Artist",
        "Lighting & Rendering Artist",
        "Product Visualizer",
        "Game Asset Designer",
        "Architectural Visualizer",
      ],
    },
    {
      title: "PRO 3D ANIMATOR",
      duration: "3 Months",
      content: "Rigging, Character Animation, Object Animation, Face Animation",
      industries: [
        "Animation & Film Studios",
        "Gaming Industry",
        "Television & OTT Content",
        "Mobile Apps & AR/VR",
        "Advertising & Creative Agencies",
        "E-learning & EdTech Platforms",
        "Medical & Scientific Visualization",
        "3D Product Marketing & Motion Ads",
      ],
      roles: [
        "3D Animator",
        "Rigging Artist",
        "Blender Generalist",
        "Facial Animation Artist",
        "3D Game Animator",
        "Freelance 3D Content Creator",
      ],
    },
    {
      title: "3D MASTERY",
      duration: "6 Months",
      content: "Modeling, Texturing, Lighting, Rigging, Animation, Rendering",
      industries: [
        "Animation & Film Studios",
        "E-commerce Product Visualization",
        "Gaming Industry",
        "Television & OTT Content",
        "Mobile Apps & AR/VR",
        "Advertising & Creative Agencies",
        "E-learning & EdTech Platforms",
        "Medical & Scientific Visualization",
        "Industrial & Mechanical Animation",
        "3D Product Marketing & Motion Ads",
      ],
      roles: [
        "3D Animator <> Modeling Artist",
        "Lighting & Rendering Artist",
        "Rigging Artist <> Animation Artist",
        "3D Generalist <> Content Creator",
        "3D Game Animator",
        "Product Visualizer",
      ],
    },
    {
      title: "3D VFX COURSE",
      duration: "12 Months",
      content: "3D, VFX, Video Editing, Graphic Designing, Motion Graphics",
      industries: [
        "Film & Animation Studios",
        "Gaming & AR/VR",
        "Advertising Agencies",
        "YouTube & Content Creation",
        "EdTech & E-learning",
        "Digital Marketing",
        "Broadcast Media",
      ],
      roles: [
        "3D Artist",
        "VFX Compositor",
        "Video Editor",
        "Graphic Designer",
        "Motion Graphics Artist",
        "Content Creator",
        "Multimedia Designer",
      ],
    },
  ],
  VFX: [
    {
      title: "VFX ESSENTIALS",
      duration: "5-6 Months",
      content: "Rotoscopy, VFX Paint, Tracking, Compositing",
      industries: [
        "Film & Animation Studios",
        "OTT & TV Production",
        "Advertising & Post-production Houses",
        "Gaming & AR/VR",
        "E-learning & EdTech Content",
      ],
      roles: [
        "Roto Artist",
        "Paint & Prep Artist",
        "Matchmove/Tracking Artist",
        "Compositor",
        "VFX Generalist",
      ],
    },
    {
      title: "VFX MASTERY",
      duration: "7-8 Months",
      content:
        "Rotoscopy, VFX Paint, Tracking, Compositing, Image Editing, Matte Painting, Motion graphics, Visual Effects, Professional Video Editing, Transitions, Audio Editing, Vector-Based Design Logos, Icons, Illustrations",
      industries: [
        "Animation & Film Studios",
        "Gaming Industry",
        "Television & OTT Content",
        "Mobile Apps & AR/VR",
        "Advertising Agencies",
        "Scientific Visualization",
        "3D Product Marketing & Motion Ads",
      ],
      roles: [
        "Roto Artist",
        "Paint & Prep Artist",
        "Tracking Artist",
        "Matte Painter",
        "Compositor",
        "VFX Artist",
        "Motion Graphics Artist",
        "Video Editor",
        "Audio Editor",
        "Graphic Designer",
      ],
    },
    {
      title: "3D VFX COURSE",
      duration: "12 Months",
      content: "3D, VFX, Video Editing, Graphic Designing, Motion Graphics",
      industries: [
        "Film & Animation Studios",
        "Gaming & AR/VR",
        "Advertising Agencies",
        "YouTube & Content Creation",
        "EdTech & E-learning",
        "Digital Marketing",
        "Broadcast Media",
      ],
      roles: [
        "3D Artist",
        "VFX Compositor",
        "Video Editor",
        "Graphic Designer",
        "Motion Graphics Artist",
        "Content Creator",
        "Multimedia Designer",
      ],
    },
  ],
  GAMING: [
    {
      title: "PRO 3D CREATOR",
      duration: "3 Months",
      content: "Modeling, Texturing, Lighting, Rendering",
      industries: [
        "Film & Animation Studios",
        "Gaming Industry",
        "Architectural & Interior Design Studios",
        "Advertising Agencies",
        "E-commerce Product Visualization",
        "Medical & Scientific Visualization",
        "Industrial & Mechanical Animation",
        "E-learning & Educational Content Development",
      ],
      roles: [
        "3D Artist",
        "Modeling Artist",
        "Lighting & Rendering Artist",
        "Product Visualizer",
        "Game Asset Designer",
        "Architectural Visualizer",
      ],
    },
    {
      title: "PRO 3D ANIMATOR",
      duration: "3 Months",
      content: "Rigging, Character Animation, Object Animation, Face Animation",
      industries: [
        "Animation & Film Studios",
        "Gaming Industry",
        "Television & OTT Content",
        "Mobile Apps & AR/VR",
        "Advertising & Creative Agencies",
        "E-learning & EdTech Platforms",
        "Medical & Scientific Visualization",
        "3D Product Marketing & Motion Ads",
      ],
      roles: [
        "3D Animator",
        "Rigging Artist",
        "Blender Generalist",
        "Facial Animation Artist",
        "3D Game Animator",
        "Freelance 3D Content Creator",
      ],
    },
  ],
  VIDEO_EDITING: [
    {
      title: "ADVANCED DIGITAL DESIGN MASTERY",
      duration: "4 Months",
      content:
        "Image Editing, Retouching, Compositing, Logo Creation, Vector Illustrations, Branding Design, Motion Graphics, Visual Effects, Professional Video Editing, Transitions, Color Correction, Audio Editing, Noise Reduction, Sound Mixing",
      roles: [
        "Graphic Designer",
        "Visual Artist",
        "Motion Graphics Designer",
        "Video Editor",
        "VFX Compositor",
        "Audio Editor",
        "Content Creator",
      ],
      industries: [
        "Advertising & Creative Agencies",
        "Film & Post-Production Studios",
        "Animation & VFX Studios",
        "Broadcast Media & OTT Platforms",
        "Digital Marketing Companies",
        "E-learning & Educational Content Creators",
        "Gaming and App Development Studios",
      ],
    },
    {
      title: "ESSENTIAL VIDEO EDITING COURSE",
      duration: "2 Months",
      content:
        "Image Editing, Retouching, Creative Design, Video Editing, Transitions, Audio Syncing, and Color Correction",
      roles: [
        "Graphic Designer",
        "Visual Content Creator",
        "Video Editor",
        "Social Media Content Editor",
      ],
      industries: [
        "Advertising & Creative Agencies",
        "Film & Post-Production Studios",
        "Social Media & Digital Marketing",
        "Broadcast Media & OTT Platforms",
      ],
    },
    {
      title: "VISUAL DESIGN & VIDEO CREATION",
      duration: "3 Months",
      content:
        "Image Editing & Creative Design, Logo & Vector Illustration, Video Editing, Transitions, Titles, Color Grading, and Content Creation",
      roles: [
        "Graphic Designer",
        "Brand Visual Designer",
        "Video Editor",
        "Content Creator",
        "Social Media Designer",
      ],
      industries: [
        "Advertising & Creative Agencies",
        "Digital Marketing Companies",
        "Film & Post-Production Studios",
        "Social Media & Influencer Marketing",
        "E-commerce and Branding Studios",
      ],
    },
  ],
  MOTION_GRAPHICS: [
    {
      title: "MOTION GRAPHICS",
      duration: "3-4 Months",
      content:
        "Basics of Graphic Design, Animation Principles, Text & Shape Animation, Audio, Transitions & Visual Effects, Planning & Storyboarding, Advanced Techniques (3D, Tracking, Expressions), Project Workflow and Exporting, Motion Tracking & Stabilization",
      roles: [
        "Graphic Designer",
        "Visual Artist",
        "Motion Graphics Designer",
        "VFX Compositor",
        "Audio Editor",
        "Content Creator",
      ],
      industries: [
        "Advertising & Creative Agencies",
        "Film & Post-Production Studios",
        "Animation & VFX Studios",
        "Broadcast Media & OTT Platforms",
        "Digital Marketing Companies",
        "E-learning & Educational Content Creators",
        "Gaming and App Development Studios",
      ],
    },
  ],
  GRAPHIC_DESIGN: [
    {
      title: "2D ANIMATION & CONTENT CREATION COURSE",
      duration: "4 Months",
      content:
        "Photo editing, retouching, and creative graphic design, Logo design, branding, and vector artwork, Video editing, transitions, color grading, and audio mixing, 2D animation, interactive content creation, and web exports",
      roles: [
        "Graphic Designer",
        "Video Editor",
        "Animator",
        "Motion Graphics Artist",
        "Branding Specialist",
      ],
      industries: [
        "Advertising & Marketing",
        "Film & Television",
        "Digital Media & Content Creation",
        "E-Learning & EdTech",
      ],
    },
    {
      title: "ADVANCED DIGITAL DESIGN MASTERY",
      duration: "4 Months",
      content:
        "Image Editing, Retouching, Compositing, Logo Creation, Vector Illustrations, Branding Design, Motion graphics, Visual Effects, Professional video editing, transitions, Color correction, Audio editing, Noise reduction, Sound mixing",
      roles: [
        "Graphic Designer",
        "Visual Artist",
        "Motion Graphics Designer",
        "Video Editor",
        "VFX Compositor",
        "Audio Editor",
        "Content Creator",
      ],
      industries: [
        "Advertising & Creative Agencies",
        "Film & Post-Production Studios",
        "Animation & VFX Studios",
        "Broadcast Media & OTT Platforms",
        "Digital Marketing Companies",
        "E-learning & Educational Content Creators",
        "Gaming and App Development Studios",
      ],
    },
  ],
  UI_UX_DESIGN: [
    {
      title: "UI / UX DESIGNING COURSE",
      duration: "3-4 Months",
      content:
        "Creating layouts, mockups, Logo design, icon sets, visual branding elements, Designing social media creatives and landing pages, Figma, Canva, HTML, CSS, JavaScript, WordPress, Bootstrap",
      roles: [
        "UI Designer",
        "UX Designer",
        "Web Designer",
        "Front-End Developer",
        "Graphic & Visual Designer",
        "WordPress Developer",
        "Product Designer (Entry-level)",
      ],
      industries: [
        "IT & Software Companies",
        "Web & App Development Firms",
        "Digital Marketing Agencies",
        "E-commerce & Startups",
        "Creative & Branding Studios",
        "EdTech and Online Platforms",
      ],
    },
  ],
};

const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    user_courses: [],
  });

  const openCourseModal = (course) => {
    if (course === "GAMING") {
      setIsModalOpen(true);
    } else {
      setSelectedCourse(course);
    }
  };

  const closeCourseModal = () => setSelectedCourse(null);
  const handleButtonClick = () => setIsModalOpen(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedCourses = checked
        ? [...prev.user_courses, value]
        : prev.user_courses.filter((course) => course !== value);
      return { ...prev, user_courses: updatedCourses };
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const { user_name, user_phone, user_courses } = formData;

    // Validation
    if (!user_name || !user_phone) {
      toast.error("Please fill in all the required fields.");
      return;
    }

    if (!/^\d{10}$/.test(user_phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    if (user_courses.length === 0) {
      toast.error("Please select at least one course.");
      return;
    }

    const templateParams = {
      user_name: formData.user_name,
      user_phone: formData.user_phone,
      user_courses: formData.user_courses.join(", "),
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success(
            " Thank you for registering!  our team will contact you soon."
          );
          setIsModalOpen(false);
          setFormData({
            user_name: "",
            user_phone: "",
            user_courses: [],
          });
        },
        (error) => {
          toast.error("Failed to send email. Please try again.");
          console.error(error);
        }
      );
  };

  return (
    <>
      <section
        id="courses"
        className="flex flex-col items-center bg-[#090522] text-white py-12 px-6 -mb-1" // Added -mb-1 to remove gap
      >
        <h2 className="text-4xl text-yellow-400 font-bold mb-4 text-center">
          <span className="text-orange-400">C</span>OURSES
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl text-center mb-10">
          We offer a variety of professional courses tailored to industry
          demands.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {[
            { name: "ANIMATION", img: animation },
            { name: "VFX", img: vfx },
            { name: "GAMING", img: gaming },
            { name: "VIDEO_EDITING", img: videoEditing },
            { name: "MOTION_GRAPHICS", img: motionGrahics },
            { name: "GRAPHIC_DESIGN", img: GraphicDesign },
            { name: "UI_UX_DESIGN", img: UIUX },
          ].map(({ name, img }) => (
            <div
              key={name}
              className="bg-black rounded-lg overflow-hidden shadow-lg cursor-pointer transform transition-transform duration-300 hover:scale-105"
              onClick={() => openCourseModal(name)}
            >
              <img
                src={img}
                alt={name}
                loading="lazy"
                className="w-full h-60 object-cover"
              />
              <div className="bg-black bg-opacity-80 text-center py-2 font-semibold">
                {name === "UI_UX_DESIGN"
                  ? "UI/UX DESIGN"
                  : name === "ANIMATION"
                  ? "3D ANIMATION"
                  : name.replace("_", " ")}
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedCourse && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 px-4 overflow-y-auto">
            <div className="bg-[#f7a370] bg-opacity-70 rounded-lg shadow-2xl p-6 relative w-[95%] h-[95vh] overflow-y-auto">
              <button
                onClick={closeCourseModal}
                className="absolute top-4 right-6 text-white text-4xl font-bold z-50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-red-700"
              >
                ×
              </button>

              <h3 className="text-4xl font-bold text-center text-[#310f5d] mb-10">
                {selectedCourse === "UI_UX_DESIGN"
                  ? "UI/UX DESIGN"
                  : selectedCourse === "ANIMATION"
                  ? "3D ANIMATION"
                  : selectedCourse.replace("_", " ")}
              </h3>

              <div className="flex flex-col items-center">
                <div className="flex flex-wrap justify-center gap-6 items-stretch">
                  {courseDetails[selectedCourse]?.map((course, idx) => {
                    const boxColors = [
                      "#9e987ab3",
                      "#bb5451b3",
                      "#fbbc64b3",
                      "#629d99b3",
                    ];
                    const bgColor = boxColors[idx % boxColors.length];
                    const isOdd = idx % 2 === 0;
                    return (
                      <div
                        key={idx}
                        className="flex flex-col justify-between rounded-lg p-4 shadow-md text-black bg-opacity-10 min-w-[280px] max-w-sm w-full sm:w-[45%] md:w-[45%] lg:w-[23%]"
                        style={{ backgroundColor: bgColor }}
                      >
                        <div className="flex-grow">
                          <h4 className="text-xl font-bold mb-2 text-black">
                            {course.title}
                          </h4>
                          <hr className="border-t-2 border-[#310f5d]" />

                          <p className="mt-2">
                            <span
                              className={`${
                                isOdd ? "text-white" : "text-[#310f5d]"
                              } font-bold`}
                            >
                              Duration:
                            </span>{" "}
                            <span
                              className={`${
                                isOdd ? "text-[#310f5d]" : "text-white"
                              }`}
                            >
                              {course.duration}
                            </span>
                          </p>
                          <hr className="border-t-1 mt-2 border-[#310f5d]" />

                          <p className="mt-2">
                            <span
                              className={`${
                                isOdd ? "text-white" : "text-[#310f5d]"
                              } font-bold`}
                            >
                              Content:
                            </span>{" "}
                            <span
                              className={`${
                                isOdd ? "text-[#310f5d]" : "text-white"
                              }`}
                            >
                              {course.content}
                            </span>
                          </p>
                          <hr className="border-t-1 mt-2 border-[#310f5d]" />

                          <div className="mt-2">
                            <h5
                              className={`font-bold mb-1 ${
                                isOdd ? "text-white" : "text-[#310f5d]"
                              }`}
                            >
                              Career Industries:
                            </h5>
                            <ul
                              className={`list-disc ml-4 text-sm ${
                                isOdd ? "text-[#310f5d]" : "text-white"
                              }`}
                            >
                              {course.industries.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                          <hr className="border-t-1 mt-2 border-[#310f5d]" />

                          <div className="mt-2">
                            <h5
                              className={`font-bold mb-1 ${
                                isOdd ? "text-white" : "text-[#310f5d]"
                              }`}
                            >
                              Career Roles:
                            </h5>
                            <ul
                              className={`list-disc ml-4 text-sm ${
                                isOdd ? "text-[#310f5d]" : "text-white"
                              }`}
                            >
                              {course.roles.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div className="flex justify-center mt-auto pt-4">
                          <button
                            onClick={() => {
                              closeCourseModal();
                              handleButtonClick();
                            }}
                            className="bg-[#38126a] text-white font-bold py-2 px-4 rounded-full hover:bg-[#290e4d]"
                          >
                            Know More
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Form Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="w-[85%] md:w-2/4 bg-black/70 p-6 rounded-lg mt-10 md:mt-0 relative">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-3 right-3 text-white text-2xl"
              >
                &times;
              </button>

              <h2 className="text-yellow-400 text-xl font-bold mb-4">
                Hey buddy! Fill the form for FREE counselling on VFX & 3D
                Animation courses!
              </h2>
              <form className="flex flex-col space-y-4" onSubmit={sendEmail}>
                <input
                  type="text"
                  name="user_name"
                  placeholder="NAME"
                  value={formData.user_name}
                  onChange={handleChange}
                  required
                  className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
                />
                <input
                  type="text"
                  name="user_phone"
                  placeholder="PHONE NUMBER"
                  value={formData.user_phone}
                  onChange={handleChange}
                  required
                  className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
                />
                <div className="text-white space-y-2">
                  {[
                    "3D Animation",
                    "VFX",
                    "Game Development",
                    "Video Editing",
                    "Motion Graphics",
                    "Graphics Design",
                    "UI/UX Design",
                  ].map((option, index) => {
                    const val = option.toLowerCase().replace(/\s+/g, "-");
                    return (
                      <label
                        key={index}
                        className="flex items-center space-x-2"
                      >
                        <input
                          type="checkbox"
                          value={val}
                          onChange={handleCheckboxChange}
                          className="accent-yellow-400"
                        />
                        <span>{option}</span>
                      </label>
                    );
                  })}
                </div>
                <button
                  type="submit"
                  className="p-3 rounded bg-gradient-to-r from-yellow-400 to-yellow-200 font-bold text-black hover:from-yellow-300 hover:to-yellow-500"
                >
                  REGISTER
                </button>
              </form>
            </div>
          </div>
        )}
      </section>

      {/* Button Section */}
      <ScrollToHomeButton />
    </>
  );
};

export default Courses;
